import { render } from "./HomeModalNewAlbum.vue?vue&type=template&id=30091d56"
import script from "./HomeModalNewAlbum.vue?vue&type=script&lang=js"
export * from "./HomeModalNewAlbum.vue?vue&type=script&lang=js"
script.render = render

export default script